// extracted by mini-css-extract-plugin
module.exports = {"headingLabel":"heading-label_headingLabel__Zaesn"};